<script lang="ts" setup>
import pdfIcon from '@/assets/icons/blog/pdf.svg'
import jpgIcon from '@/assets/icons/blog/jpg.svg'
import showMoreIcon from '@/assets/icons/blog/plush/show-more.svg'

interface TDownloadableAsset {
    filename: string
    links: {
        site: {
            href: string
        }
    }
}

const props = defineProps<{ data: TDownloadableAsset[] }>()

const documents = props.data.map((asset) => ({
    name: asset.filename,
    url: asset.links.site.href,
    isPdf: asset.links.site.href.endsWith('.pdf'),
}))

const initialVisibleDocuments = 2
const isShowMore = ref(false)

const displayedDocuments = computed(() => (isShowMore.value ? documents : documents.slice(0, initialVisibleDocuments)))

const shouldShowToggleButton = computed(() => documents.length > initialVisibleDocuments)
</script>

<template>
    <section class="page-plus">
        <p class="mb-6 font-bold">Pobierz Materiały</p>
        <ul>
            <li
                v-for="doc in displayedDocuments"
                :key="doc.name"
                class="mb-4 flex items-center gap-2"
            >
                <AtomImage :src="doc.isPdf ? pdfIcon : jpgIcon" />
                <a
                    :href="doc.url"
                    target="_blank"
                    class="pl-0 text-base"
                >
                    {{ doc.name }}
                </a>
            </li>
        </ul>
        <button
            v-if="shouldShowToggleButton"
            tabindex="0"
            class="flex cursor-pointer items-center gap-2"
            @click="isShowMore = !isShowMore"
            @keydown.enter.prevent="isShowMore = !isShowMore"
            @keydown.space.prevent="isShowMore = !isShowMore"
        >
            {{ isShowMore ? 'pokaż mniej' : 'pokaż więcej' }}
            <AtomImage
                :src="showMoreIcon"
                :img-class="[isShowMore ? 'rotate-180' : 'rotate-0']"
            />
        </button>
    </section>
</template>
